export default __webpack_public_path__ + "static/media/011-rhombus-orange.20a44708.svg";